import { useState } from 'react';
import API_ROUTES, { apiRoutes } from './apiRoutes';
import { useFetch } from './useFetch';

export const useChangePassword = () => {
    const [loading, setLoading] = useState(false);
    const [error, setError] = useState(null);
    const [success, setSuccess] = useState(false);
    const { fetchWithAuth } = useFetch();

    const changePassword = async ({ currentPassword, newPassword }) => {
        setLoading(true);
        setError(null);
        setSuccess(false);

        try {
            const response = await fetchWithAuth(API_ROUTES.LOGIN.updatePass(), {
                method: 'POST',
                headers: {
                    'Content-Type': 'application/json',
                    'Authorization': `Bearer ${localStorage.getItem('token')}`
                },
                body: JSON.stringify({
                    current_password: currentPassword,
                    new_password: newPassword
                })
            });

            if (!response.ok) {
                setSuccess(true)
            }

            setSuccess(true);
        } catch (err) {
            setError(err.message);
        } finally {
            setLoading(false);
        }
    };

    return { changePassword, loading, error, success };
};
